import { db } from "@/utils/firebase";
import { doc, getDoc } from "firebase/firestore";

// Function to fetch user by doc ID
const getProfile = async (userId) => {
  try {
    const userDocRef = doc(db, "users", userId); // Reference to the specific user document
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      return userDoc.data(); // Return the data
    } else {
      throw new Error(`User with ID ${userId} does not exist.`);
    }
  } catch (error) {
    console.error("Error fetching user by ID:", error.message || error);
    throw new Error("Failed to fetch user. Please try again later.");
  }
};

export default getProfile;
